import React from "react";
import { Breadcrumbs, Breadcrumb } from "@blueprintjs/core";

import { Toolbar } from "../Toolbar";
import { FilterToolbar } from "../FilterToolbar";
import styles from "./ReportingOverview.module.scss";
import moment from "moment";

import { useHistory } from "react-router-dom";

function ReportingPageHeader({
  filters,
  filterOptions,
  setFilters = () => {},
  product,
  video
}) {
  const history = useHistory();

  const BREADCRUMBS = [
    { text: "Reporting" },
    { onClick: () => history.push("/reporting"), text: "Overview" }
  ];

  if (video) {
    BREADCRUMBS.push({
      onClick: () => history.push(`/reporting/video/${video.id}`),
      text: video.name
    });
  } else if (product) {
    BREADCRUMBS.push({
      onClick: () => history.push(`/reporting/product/${product.id}`),
      text: product.name
    });
  }

  return (
    <>
      <Toolbar title="Reporting" className={styles.reportingPageHeader}>
        <FilterToolbar
          value={filters}
          onChange={setFilters}
          filterOptions={filterOptions}
        />
      </Toolbar>
      <div className={styles.breadcrumbs}>
        <Breadcrumbs
          items={BREADCRUMBS}
          currentBreadcrumbRenderer={({ text, ...restProps }) => (
            <Breadcrumb className={styles.breadcrumb} {...restProps}>
              {text}
            </Breadcrumb>
          )}
        />
        <div className={styles.lastUpdated}>
          Updated {moment(new Date()).format("MMMM D, YYYY hh:mm A")}
        </div>
      </div>
    </>
  );
}

export default ReportingPageHeader;
